import { X } from "lucide-react";
import { useEffect, useRef, type ReactNode } from "react";

/** A small dialog. Escape or the × closes it; focus starts inside it. */
export function Modal({ title, onClose, children }: { title: string; onClose: () => void; children: ReactNode }) {
  const ref = useRef<HTMLDialogElement>(null);
  useEffect(() => {
    const d = ref.current;
    if (d && !d.open) d.showModal();
    return () => d?.close();
  }, []);
  return (
    <dialog ref={ref} className="modal" onCancel={(e) => { e.preventDefault(); onClose(); }} aria-label={title}>
      <header><h3>{title}</h3><button type="button" className="icon-link" aria-label="Close" onClick={onClose}><X size={18} /></button></header>
      <div className="modal-body">{children}</div>
    </dialog>
  );
}
